@use '../../design-tokens/typography/typography' as *;

@layer design-system {
  .root {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .inputContainer {
    display: flex;
    padding-left: 12px;
    gap: 8px;
    align-items: center;
    flex: 1 0 0;
    border: 1px solid var(--border-soft);
    border-radius: 40px;
    height: 40px;
    overflow: hidden;
  }

  .input {
    flex: 1;
    border: none;
    background-color: transparent;
    caret-color: var(--text-primary);
    -moz-appearance: textfield;
    border-color: transparent;

    &:active,
    &:hover,
    &:focus-within {
      border-color: transparent;
      outline: none;
    }

    &::placeholder {
      color: var(--text-soft);
      @include typography-v2-body-sm;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    @include typography-v2-body-base;
    width: 100%;
    color: inherit;
    cursor: pointer;
    padding: 0 20px 0 0;
  }

  .searchIcon {
    display: flex;
    align-items: center;

    svg {
      fill: var(--icon-soft);
    }
  }
}
